const imageUnavailable = {
    methods: {
        imageUnavailable(event) {
            event.target.src = "/assets/images/no_car_image.svg";
        }
    }
};

export default imageUnavailable;
